/* eslint-disable @typescript-eslint/no-unsafe-enum-comparison -- many errors not worth fixing since this feature needs to be refactored */
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import { MRT_Row } from "material-react-table";
import { useState, useRef } from "react";

import AddConceptButton from "@/features/portfolio/components/buttons/AddConcept";
import CloneConceptButton from "@/features/portfolio/components/buttons/CloneConcept";
import CloneProjectButton from "@/features/portfolio/components/buttons/CloneProject";
import EditConceptButton from "@/features/portfolio/components/buttons/EditConcept";
import EditProjectButton from "@/features/portfolio/components/buttons/EditProject";
import {
  PortfolioRowModel,
  Project,
  Concept,
} from "@/features/portfolio/models/portfolioModel";

type PortfolioRowActionsProps = {
  key: string;
  row: MRT_Row<PortfolioRowModel>;
  refetchProjects: () => Promise<void>;
  addCloneProject: (newProject: Project) => void;
  addCloneConcept: (newConcept: Concept) => void;
  portfolioData: PortfolioRowModel[];
};

export default function PortfolioRowActions({
  row,
  refetchProjects,
  addCloneProject,
  addCloneConcept,
  portfolioData,
}: PortfolioRowActionsProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const anchorRef = useRef(null);

  const handleOpenMenu = () => {
    setAnchorEl(anchorRef.current);
    setIsMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
    setAnchorEl(null);
  };

  return (
    <Box>
      <IconButton ref={anchorRef} onClick={handleOpenMenu}>
        <MoreVertIcon />
      </IconButton>
      <Popover
        open={isMenuOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handleCloseMenu}>
        {row.original.type === 1 && (
          <>
            <EditProjectButton
              row={row}
              closePopover={handleCloseMenu}
              refetchProjects={refetchProjects}
              portfolioData={portfolioData}
            />
            <AddConceptButton
              projectId={row.original.id}
              refetchProjects={refetchProjects}
              closePopover={handleCloseMenu}
              portfolioData={portfolioData}
            />
            <CloneProjectButton
              project={row.original}
              closePopover={handleCloseMenu}
              addCloneProject={addCloneProject}
            />
          </>
        )}
        {row.original.type === 2 && (
          <>
            <EditConceptButton
              row={row}
              closePopover={handleCloseMenu}
              refetchProjects={refetchProjects}
              portfolioData={portfolioData}
            />
            <CloneConceptButton
              concept={row.original}
              projectCode={(row.getParentRow()?.original?.children?.length ?? 0) + 1}
              addCloneConcept={addCloneConcept}
              closePopover={handleCloseMenu}
            />
          </>
        )}
      </Popover>
    </Box>
  );
}
